var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"color":"blue-gray lighten-4","depressed":"","ripple":false},on:{"click":function($event){return _vm.$router.go(-1)}}},'v-btn',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.$t('general.backButton'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }